import Home from "@/components/Home";
import Manage from "@/components/Manage/Manage";

export default [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: { name: "Manage", params: { slug: ((typeof window.initPage != 'undefined')?window.initPage: "updates")} },
    children: [
      {
        path: "/page/:slug",
        name: "Manage",
        component: Manage
      }
    ],
  }
];
